// Syntetizované náhrady zvuků zvířat. Nejsou realistické, ale každé zní jinak a dá se zapamatovat.
// Jakmile v /sounds/manifest.json bude soubor se stejným jménem, použije se místo nich.
import { noise, registerSynth, tone } from "../../audio.ts";

function vibrato(c: AudioContext, t: number, dur: number, base: number, rate: number, depth: number, type: OscillatorType, gain: number, out: AudioNode, to?: number) {
  const o = c.createOscillator();
  const lfo = c.createOscillator();
  const lfoGain = c.createGain();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(base, t);
  if (to) o.frequency.linearRampToValueAtTime(to, t + dur);
  lfo.frequency.value = rate;
  lfoGain.gain.value = depth;
  lfo.connect(lfoGain).connect(o.frequency);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + 0.05);
  g.gain.setValueAtTime(gain, t + dur - 0.1);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(out);
  o.start(t);
  lfo.start(t);
  o.stop(t + dur + 0.02);
  lfo.stop(t + dur + 0.02);
}

registerSynth("pes", (c, o, t) => {
  for (const d of [0, 0.28]) {
    tone(c, o, t + d, 260, 0.14, { type: "square", to: 160, gain: 0.25 });
    noise(c, o, t + d, 0.12, { freq: 700, q: 2, gain: 0.3 });
  }
  return 0.5;
});
registerSynth("krava", (c, o, t) => {
  vibrato(c, t, 1.1, 150, 5, 4, "sawtooth", 0.15, o, 115);
  return 1.15;
});
registerSynth("prase", (c, o, t) => {
  for (let i = 0; i < 3; i++) {
    noise(c, o, t + i * 0.13, 0.09, { freq: 350, q: 4, gain: 0.5 });
    tone(c, o, t + i * 0.13, 180, 0.08, { type: "sawtooth", gain: 0.1 });
  }
  return 0.45;
});
registerSynth("kachna", (c, o, t) => {
  for (const d of [0, 0.25]) tone(c, o, t + d, 620, 0.18, { type: "square", to: 480, gain: 0.15 });
  return 0.45;
});
registerSynth("kun", (c, o, t) => {
  vibrato(c, t, 0.9, 1000, 18, 120, "triangle", 0.2, o, 450);
  return 0.95;
});
registerSynth("slepice", (c, o, t) => {
  [0, 0.12, 0.24, 0.42].forEach((d, i) => tone(c, o, t + d, i === 3 ? 1300 : 900, i === 3 ? 0.3 : 0.07, { type: "triangle", gain: 0.25, to: i === 3 ? 1000 : undefined }));
  return 0.75;
});
registerSynth("zaba", (c, o, t) => {
  for (const d of [0, 0.22]) vibrato(c, t + d, 0.16, 230, 60, 80, "square", 0.12, o);
  return 0.4;
});
registerSynth("slon", (c, o, t) => {
  vibrato(c, t, 0.9, 350, 7, 30, "sawtooth", 0.18, o, 700);
  return 0.95;
});
registerSynth("sova", (c, o, t) => {
  tone(c, o, t, 420, 0.35, { gain: 0.35, attack: 0.08, to: 390 });
  tone(c, o, t + 0.45, 420, 0.55, { gain: 0.35, attack: 0.08, to: 380 });
  return 1.0;
});
registerSynth("opice", (c, o, t) => {
  for (let i = 0; i < 3; i++) tone(c, o, t + i * 0.16, 500, 0.14, { type: "triangle", gain: 0.3, to: 1300 });
  return 0.5;
});
registerSynth("koza", (c, o, t) => {
  vibrato(c, t, 0.7, 520, 22, 40, "sawtooth", 0.12, o, 480);
  return 0.75;
});
registerSynth("had", (c, o, t) => {
  noise(c, o, t, 0.9, { freq: 6500, q: 0.7, gain: 0.35 });
  return 0.9;
});
